import { apiClient } from "./apiClient";

export type BroadcastTemplate =
  | "today_profit"
  | "today_report"
  | "week_profit"
  | "week_report"
  | "month_profit"
  | "month_report"
  | "subscription_reminder"
  | "custom";

export type BroadcastChannel = "telegram" | "email";

export interface BroadcastRequest {
  recipient_ids: string[];
  all_users: boolean;
  template: BroadcastTemplate;
  title?: string | null;
  message?: string | null;
  delivery_channels: BroadcastChannel[];
}

export interface ChannelResult {
  delivered: boolean;
  reason: string | null;
}

export interface RecipientResult {
  user_id: string;
  email: string;
  name: string | null;
  telegram: ChannelResult;
  email_result: ChannelResult;
  inapp_created: boolean;
  status: "sent" | "skipped" | "failed";
  reason: string | null;
}

export interface BroadcastResponse {
  total: number;
  sent: number;
  skipped: number;
  failed: number;
  results: RecipientResult[];
}

export async function sendBroadcast(
  request: BroadcastRequest
): Promise<BroadcastResponse> {
  const response = await apiClient.post<BroadcastResponse>(
    "/admin/broadcast",
    request
  );
  return response.data;
}
